import ResizeObserver from 'resize-observer-polyfill';

export default {
    data() {
        return {
            selfWidth: 0,
            resizeObserver: null,
        };
    },

    mounted() {
        this.resizeObserver = new ResizeObserver(() => {
            requestAnimationFrame(() => {
                this.selfWidth = this.$el?.getBoundingClientRect()?.width ?? 0;
            });
        });
        this.resizeObserver.observe(this.$el);
    },

    beforeUnmount() {
        this.resizeObserver?.disconnect();
    },

    computed: {
        isXs() {
            return this.selfWidth < 640;
        },

        isSm() {
            return this.selfWidth >= 640;
        },

        isMd() {
            return this.selfWidth >= 768;
        },

        isLg() {
            return this.selfWidth >= 1024;
        },

        isXl() {
            return this.selfWidth >= 1280;
        },

        is2Xl() {
            return this.selfWidth >= 1536;
        },
    },
};
